import React, { ReactElement, ReactNode } from 'react';
import classNames from 'classnames';
import { uniqueId } from 'lodash';

import './style.scss';
import { InputLabel } from '../InputLabel/component';
import { AutoSaveState } from '../AutoSaveIndicator/component';

export interface SelectOption {
  value: string;
  label: string;
  disabled?: boolean;
}

export declare interface SelectProps {
  name?: string;
  label?: string | ReactElement;
  value?: string;
  className?: string;
  options: SelectOption[];
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  onValueChange?: (value: string) => void;
  description?: ReactNode;
  error?: string | null;
  required?: boolean;
  disabled?: boolean;
  autoSave?: boolean;
  autoSaveState?: AutoSaveState;
  onFocus?: (event: React.FocusEvent<HTMLSelectElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLSelectElement>) => void;
}

export class Select extends React.PureComponent<SelectProps> {
  private inputId: string;

  public constructor(props: SelectProps) {
    super(props);

    this.inputId = uniqueId();
  }

  private onChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    const { onChange, onValueChange } = this.props;

    if (onChange) {
      onChange(event);
    }

    if (onValueChange) {
      onValueChange(event.target.value);
    }
  };

  public render(): ReactNode {
    const {
      name = `select-${this.inputId}`,
      className = null,
      label = null,
      description = null,
      error = null,
      value = '',
      options,
      required = false,
      disabled = false,
      autoSave = false,
      autoSaveState,
      onFocus,
      onBlur,
    } = this.props;

    return (
      <div className={classNames('ol-select', className)}>
        {label && (
          <InputLabel
            htmlFor={this.inputId}
            error={error}
            required={required}
            autoSave={autoSave}
            autoSaveState={autoSaveState}
          >
            {label}
          </InputLabel>
        )}
        {description && (
          <span className="ol-select-description">{description}</span>
        )}
        <select
          {...{ name, required, disabled }}
          className="ol-select-select"
          onChange={this.onChange}
          id={this.inputId}
          value={value || ''}
          onFocus={onFocus}
          onBlur={onBlur}
        >
          {options.map((option, i) => {
            const key = `option-${option.value}-${i}`;
            return (
              <option value={option.value} key={key} disabled={option.disabled}>
                {option.label}
              </option>
            );
          })}
        </select>
      </div>
    );
  }
}
